<template lang="html">
  <div class="lessons-view">
    <v-container>
      <v-row>
      <v-btn fab text small @click="$refs.calendar.prev()">
      <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date_text"
            label="Hónap választása"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="today" @input="menu2 = false">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="today = new Date().toISOString().slice(0,10)">Mai nap</v-btn>
        </v-date-picker>
      </v-menu>
      <v-btn fab text small @click="$refs.calendar.next()">
      <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
      </v-row>
      <v-row>
      <v-col cols="12" md="5">
      <v-select
        v-model="training_place_select"
        :items="training_places"
        item-text="place_name"
        item-value="training_place_id"
        label="Oktatási helyszín"
        outlined
      ></v-select>
      </v-col>
      <v-col cols="8" md="5">
      <v-select
        v-model="course_pattern_select"
        :items="course_patterns"
        item-text="name"
        item-value="course_pattern_id"
        label="Tanfolyam sablon"
        outlined
      ></v-select>
      </v-col>
      <v-col cols="2" md="2">
      <v-btn text large @click="training_place_select = null, course_pattern_select = null, lessons = null">Töröl</v-btn>
      </v-col>
      </v-row>
      <v-row>
        <v-btn v-if="type == 'day' && lessons "text large @click="type = 'month'">Hónap nézet</v-btn>
      </v-row>
        <div v-if="!lessons">
          <v-row
          align="center"
          justify="center"
          >
          A naptár betöltéséhez válasszon egy szűrési feltételt!
          </v-row>
          <v-row
          align="center"
          justify="center"
          >
          ("Oktatási helyszín" vagy "Tanfolyam sablon")
          </v-row>
        </div>
      <v-sheet v-if="lessons" height="600">
      <v-calendar
        ref="calendar"
        :type="type"
        v-model="today"
        :events="lessons"
        @click:more="viewDay"
        @click:event="showEvent"
        @click:date="newLesson"
        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
        interval-height="50"
      >
        <template v-slot:event="{event}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">{{event.start_time}} - {{ event.name }} ({{event.headcount}})</div>
            </template>
            <span>Létszám: {{event.headcount}}</span>
          </v-tooltip>
        </template>
      </v-calendar>
      </v-sheet>
    </v-container>

    <v-dialog v-model="lesson_details" persistent scrollable max-width="600px">
      <v-card>
        
        <v-toolbar flat>
          <v-toolbar-title>Előadás részletei</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon      
            @click="lesson_details = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text>
          <v-container>

            <v-tabs v-model="lessons_tab" show-arrows grow centered>
            <v-tabs-slider></v-tabs-slider>
            <v-layout justify-center>
              <v-tab>Előadás adatai</v-tab>
              <v-tab v-if="lesson_id">Tanulók</v-tab>
            </v-layout>
              <v-tabs-items v-model="lessons_tab" touchless>
                <v-tab-item name="lesson_details">
                  <v-form
                    ref="lesson_save_form"
                    v-model="valid"
                    lazy-validation
                  >
                  <br>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="lesson_pattern_id"
                        :items="lesson_patterns"
                        item-text="name"
                        item-value="lesson_pattern_id"
                        label="Előadás sablon"
                        outlined
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="lesson_pattern_id"
                        :items="lesson_patterns"
                        item-text="nkh_subject_name"
                        item-value="lesson_pattern_id"
                        label="Tantárgy"
                        outlined
                        disabled
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="place_id"
                        :items="training_places"
                        item-text="place_name"
                        item-value="training_place_id"
                        label="Helyszín"
                        outlined
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="teacher_id"
                        :items="teachers"
                        item-text="name"
                        item-value="teacher_id"
                        label="Oktató"
                        outlined
                        return-object
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="date_menu"
                        v-model="date_menu"
                        :close-on-content-click="false"
                        :return-value.sync="start_date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="start_date"
                            label="Előadás dátuma"
                            outlined
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="start_date" no-title scrollable first-day-of-week=1>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="date_menu = false">Mégsem</v-btn>
                          <v-btn text color="primary" @click="$refs.date_menu.save(start_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="start_time_menu"
                        v-model="start_time_menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="lesson_start_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="lesson_start_time"
                            label="Kezdés ideje"
                            outlined
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="start_time_menu2"
                          v-model="lesson_start_time"
                          full-width
                          format="24hr"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="start_time_menu2 = false">Mégsem</v-btn>
                        <v-btn text color="primary" @click="$refs.start_time_menu.save(lesson_start_time)">OK</v-btn>
                      </v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-menu
                        ref="end_time_menu"
                        v-model="end_time_menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="lesson_end_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="lesson_end_time"
                            label="Befejezés ideje"
                            outlined
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="end_time_menu2"
                          v-model="lesson_end_time"
                          full-width
                          format="24hr"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="end_time_menu2 = false">Mégsem</v-btn>
                        <v-btn text color="primary" @click="$refs.end_time_menu.save(lesson_end_time)">OK</v-btn>
                      </v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="hours"
                        label="Óraszám"
                        outlined
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col v-if="lesson_id" cols="12" md="6">
                      <v-text-field
                        v-model="lesson_nos"
                        label="Létszám"
                        outlined
                        disabled
                        :loading="nos_load"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" text @click="lesson_details = false">Mégsem</v-btn>
                    <v-btn color="primary" text @click="archive_dialog = true">Törlés</v-btn>
                    <v-btn color="primary" text @click="validate()">Mentés</v-btn>
                  </v-card-actions>
                  </v-form>
                </v-tab-item>
                <v-tab-item name="lesson_students">
                  <v-data-table
                    v-if="lesson_students"
                    :headers="lesson_students_header"
                    :items="lesson_students"
                    :items-per-page="15"
                    :mobile-breakpoint='NaN'
                  >
                  <template v-slot:item="{ item, index }">
                    <tr :style="item.status == 'Preregistred' ? {'background': '#FFF3E0'} : ''">
                      <td>{{ index + 1 }}</td>
                      <td style='min-width: 150px'>{{ item.full_name }}</td>
                      <td style='min-width: 110px'>{{ item.date }}</td>
                      <td>{{ item.course_student_id }}</td>
                    </tr>
                  </template>
                </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="save_dialog" persistent max-width="300">
      <v-card>
        <v-card-text class="pt-4">Biztosan menteni szeretné az előadást?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveLesson(), save_dialog = false, lesson_details = false">Igen</v-btn>
          <v-btn color="primary" text @click="save_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="archive_dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-4">Biztosan törölni szeretné az előadást?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="delLesson(), archive_dialog = false, lesson_details = false">Igen</v-btn>
          <v-btn color="primary" text @click="archive_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" bottom>
      {{response_text}}
      <v-btn color="pink" text @click="snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import store from '../store'
import { mapFields } from 'vuex-map-fields'

  export default {
    data () {
      return {
        archive_dialog: false,
        save_dialog: false,
        snackbar: false,
        response_text: '',
        lessons: null,
        today: new Date().toISOString().slice(0,10),
        date_text: '',
        type: 'month',
        lesson_details: false,
        teacher_name: '',
        teacher_id: '',
        lesson_start: '',
        start_date: '',
        lesson_start_time: '',
        lesson_end_time: '',
        lesson_end: '',
        lesson_id: '',
        lesson_type: '',
        lesson_students: null,
        nkh_subject_name: '',
        place_name: '',
        lesson_nos: '',
        training_places: [],
        training_place_select: '',
        course_patterns: [],
        course_pattern_select: '',
        lessons_tab: null,
        lesson_students_header: [
          { text: ''},
          { text: 'Név', value: 'full_name'},
          { text: 'Született', value: 'date' },
          { text: 'Azonosító', value: 'course_student_id' },
        ],
        menu2: false,
        lesson_patterns: [],
        lesson_pattern_id: '',
        place_id: '',
        hours: '',
        teachers: [],
        lesson_pattern_details: null,
        start_time: null,
        end_time: null,
        new_lesson_start: null,
        new_lesson_end: null,
        nos_load: false,
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        valid: true,
        date_menu: false,
        start_time_menu2: false,
        end_time_menu2: false,
      }
    },
    methods: {
      Lessons: async function() {
        this.lessons = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_all', {
          token: this.token,
          training_place: this.training_place_select,
          course_pattern: this.course_pattern_select,
        }).then((response) => {
          store.state.showing.preloader = false
          this.lessons = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      newLesson({ date }) {
        this.teacher_name = null
        this.teacher_id = null
        this.lesson_start_time = null
        this.lesson_end_time = null
        this.start_date = null
        this.lesson_start = null
        this.lesson_end = null
        this.new_lesson_start = date
        this.new_lesson_end = date
        this.lesson_id = null
        this.lesson_type = null
        this.place_id = null
        this.lesson_nos = null
        this.lesson_pattern_id = null
        this.hours = null
        this.lesson_details = true;
      },
      saveLesson: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/save_lesson', {
          token: this.token,
          lesson_id: this.lesson_id,
          place_id: this.place_id,
          start_date: this.start_date+' '+this.lesson_start_time,
          end_date: this.start_date+' '+this.lesson_end_time,
          lesson_pattern_id: this.lesson_pattern_id,
          nkh_subject_name: this.nkh_subject_name,
          hours: this.hours,
          training_place_id: this.place_id,
          teacher_id: this.teacher_id['teacher_id'],
          teacher_name: this.teacher_id['name']
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_text = response.data[0]
          this.snackbar = true

          this.Lessons()
        }, (error) => {
          this.error_text = error.data
        })
      },
      delLesson: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/archive_lesson', {
          token: this.token,
          lesson_id: this.lesson_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_text = response.data
          this.snackbar = true

          this.Lessons()
        }, (error) => {
          this.error_text = error.data
        })
      },
      LessonStudents: async function() {
        this.nos_load = true
        this.lesson_students = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lesson_students', {
          token: this.token,
          lesson_id: this.lesson_id,
        }).then((response) => {
          this.nos_load = false
          store.state.showing.preloader = false
          this.lesson_students = response.data[0]
          this.lesson_nos = response.data[1]

        }, (error) => {
          this.error_text = error.data
        })
      },
      getPlaces: async function() {
        this.training_places = ''
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/training_places', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.training_places = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getTeachers: async function() {
        this.teachers = []
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/teachers', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.teachers = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getCoursePatterns: async function() {
        this.course_patterns = []
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/course_patterns', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_patterns = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getLessonPatterns: async function() {
        this.lesson_patterns = []
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lesson_patterns', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.lesson_patterns = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonPatternDetails: async function() {
        this.lesson_pattern_details = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lesson_pattern_details', {
          token: this.token,
          lesson_pattern_id: this.lesson_pattern_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.lesson_pattern_details = response.data
          this.hours = response.data[0]['hours']
          this.teacher_id = {"teacher_id": response.data[0]['teacher_id'], "name": response.data[0]['teacher_name']}
          this.start_time = response.data[0]['start_time']
          this.end_time = response.data[0]['end_time']
          this.nkh_subject_name = response.data[0]['nkh_subject_name']
          this.lesson_start = this.new_lesson_start+" "+this.start_time
          this.lesson_end = this.new_lesson_end+" "+this.end_time
          this.lesson_start_time = this.start_time
          this.lesson_end_time = this.end_time
          this.start_date = this.new_lesson_start

        }, (error) => {
          this.error_text = error.data
        })
      },
      refreshNknSubject: async function() {
        this.lesson_pattern_details = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lesson_pattern_details', {
          token: this.token,
          lesson_pattern_id: this.lesson_pattern_id,
        }).then((response) => {
          this.nkh_subject_name = response.data[0]['nkh_subject_name']
        }, (error) => {
          this.error_text = error.data
        })
      },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    dateToDisplay () {
      var options = { year: 'numeric', month: 'long'};
      var datum  = new Date(this.today);
      this.date_text = datum.toLocaleDateString('hu-HU',options);
    },
    viewDay ({ date }) {
      this.today = date
      this.type = 'day'
    },
    showEvent ({ event }) {
      this.lesson_details = true;
      this.teacher_name = event.teacher_name;
      this.teacher_id = {"teacher_id": event.teacher_id, "name": event.teacher_name};
      this.lesson_start = event.start;
      this.start_date = event.start_date;
      this.lesson_start_time = event.start_time;
      this.lesson_end_time = event.end_time;
      this.lesson_end = event.end;
      this.lesson_id = event.lesson_id;
      this.lesson_type = event.name;
      this.nkh_subject_name = event.nkh_subject_name;
      this.place_name = event.place_name;
      this.place_id = event.training_place_id;
      this.lesson_nos = event.count;
      this.lesson_pattern_id = event.lesson_pattern_id;
      this.hours = event.hours;
      this.LessonStudents()
    },
    validate () {
      if (this.$refs.lesson_save_form.validate()) {
        this.save_dialog = true
        }
      },
    resetValidation () {
        this.$refs.lesson_save_form.resetValidation()
      },
  },
    mounted() {
      this.getPlaces()
      this.getCoursePatterns()
      this.dateToDisplay()
      this.getLessonPatterns()
      this.getTeachers()
    },
    watch: {
      training_place_select: function (value) {
          this.Lessons()
      },
      course_pattern_select: function (value) {
          this.Lessons()
      },
      today: function (value) {
          this.dateToDisplay()
      },
      lesson_pattern_id: function (value) {
        this.refreshNknSubject()
        if (this.lesson_id == null) {
          this.resetValidation()
          this.lessonPatternDetails()
        }
      },
      headcount_update: function (value) {
        if (this.headcount_update == true) {
          this.Lessons()
        }
      },
    },
    computed: {
    ...mapFields([
    'tanfolyamok.headcount_update',
  ]),
  },
  }
</script>

<style lang="css">
</style>
